import React from 'react';
import { useController } from 'react-hook-form';
import Select from '@alfa-retail-react/components/select';
import { useFormContext } from '@alfa-retail-react/components/form-hook';

import { WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { EmploymentFormStore } from 'app/logic/pages/employment/EmploymentFormStore';
import { EmploymentFormValues } from 'app/logic/pages/employment/EmploymentPage';
import { ValidationRules } from 'app/form/ValidationRules';
import { useIsDesktop } from 'app/utils/useWindowType';

export interface ExperienceSelectFormItemProps {
    formStore: EmploymentFormStore;
}

export const ExperienceSelectFormItem = ({
    formStore,
}: ExperienceSelectFormItemProps) => {
    const EXPERIENCE_SELECT_FORM_ITEM_NAME = 'experience';

    const [isDesktop] = useIsDesktop();
    const { control, handleMultipleErrors, setFieldElement } =
        useFormContext<EmploymentFormValues>();
    const { field, fieldState } = useController<EmploymentFormValues>({
        name: EXPERIENCE_SELECT_FORM_ITEM_NAME,
        control,
        defaultValue: formStore.experience,
        rules: { required: ValidationRules.required() },
    });

    return (
        <Select
            className={WEB_VISOR_HIDE}
            componentRef={(element) => {
                field.ref(element);
                setFieldElement(EXPERIENCE_SELECT_FORM_ITEM_NAME, element);
            }}
            isDesktop={isDesktop}
            size="l"
            options={formStore.experienceReference}
            selected={String(field.value)}
            error={handleMultipleErrors(fieldState.error)}
            label={'Стаж на последнем месте работы'}
            onBlur={field.onBlur}
            onChange={(event) => {
                field.onChange(event.selected.key);
                formStore.experience = event.selected.key;
            }}
        />
    );
};
